import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { PendingRedirect, ReturnTo } from '@/helpers/redirectTo';
import { usePendingRedirect } from '@/hooks/usePendingRedirect';
import { useNewAuth } from '@/providers/AuthProvider/NewAuthProvider.hooks';
import { isKnownRoute } from '@/routes/routePatterns';
import { ERoutes } from '@/types/routes';

export const RedirectCoordinator = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useNewAuth();

  const current = location.pathname + location.search + location.hash;
  const pending = usePendingRedirect();
  const navigatedTo = useRef<string | null>(null);

  const target = !pending ? null : isKnownRoute(pending) ? pending : ERoutes.DASHBOARD;

  useEffect(() => {
    if (!isAuthenticated) return;
    if (!target) return;

    if (navigatedTo.current !== target && target !== current) {
      navigatedTo.current = target;
      navigate(target, { replace: true });

      return;
    }

    navigatedTo.current = null;
    PendingRedirect.clear();
    ReturnTo.clear();
  }, [isAuthenticated, target, current, navigate]);

  return null;
};
